import {createContext, useContext} from 'react';
import {assert} from 'assert-ts';
import type {LockProps} from './types';
import {useWorkEditState} from '../components/WorkCard/hooks';
import {useLockWorkOnOpen} from '../hooks';

export type WorkEditStateContextType = ReturnType<typeof useWorkEditState>;

export const WorkEditStateContext = createContext<
  WorkEditStateContextType | undefined
>(undefined);

export const useWorkEditStateContextProviderValue = (
  workId: string,
): {
  editState: WorkEditStateContextType;
  lockProps: LockProps;
} => {
  const {readonly, lockProps} = useLockWorkOnOpen(workId);
  const editState = useWorkEditState(readonly);

  return {editState, lockProps};
};

export const useWorkEditStateContext = (): WorkEditStateContextType => {
  return assert(
    useContext(WorkEditStateContext),
    'WorkEditStateContext: context expected',
  );
};
